import { useEffect, useRef, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CommonModal from "../../components/modal/CommonModal";
import { GET } from "../../config/httpMain";
import CommonUIApiUrl from "../../config/apiURL/commonUIAPIURL";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { encodeParam } from "../../utility/utils";
import { COMPANYCODE } from "../../constants/constant";
import { useCustomNavigation } from "../../utility/useCustomNavigation";
import { errorHandler } from "../../utility/errorHandler";

const GlobalSearch = ({
    globalSearchPopup,
    setGlobalSearchPopup
}: any) => {
    const { handleNavigate, handleNavigatePackages } = useCustomNavigation();
    const [query, setQuery] = useState('');
    const [groupedResults, setGroupedResults] = useState<Record<string, any[]>>({});
    const [indexSearchPlaceholder, setIndexSearchPlaceholder] = useState(0);
    const minChars = 3;
    const togglePopup = () => setGlobalSearchPopup((prev: any) => !prev);

    const handleChange = (e: any) => {
        const input = e.target.value;
        setQuery(input);
    }
    useEffect(() => {
        if (query.length < minChars) {
            setGroupedResults({});
            return;
        }
        const handle = setTimeout(async (e: any) => {
            if (query.length >= 3) {
                const lower = query.toLowerCase();
                GET(CommonUIApiUrl.GetGlobalSearch + "?CompanyCode=" + COMPANYCODE + "&Query=" + lower).then((response: any) => {
                    if (response?.data?.isSuccess) {
                        let listArr = response?.data?.result;

                        const grouped = listArr?.reduce((acc: Record<string, any[]>, curr: any) => {
                            if (!acc[curr.type]) acc[curr.type] = [];
                            acc[curr.type].push(curr);
                            return acc;
                        }, {});
                        setGroupedResults(grouped);
                    }
                    else
                        errorHandler("response", response);
                }).catch((e: any) => {
                    errorHandler("error", e);
                });

            } else {
                setGroupedResults({});
            }
        }, 300);
        return () => clearTimeout(handle);
    }, [query, minChars]);

    const highlightText = (text: any, query: any) => {
        const parts = text?.split(new RegExp(`(${query})`, 'gi'));
        return parts?.map((part: any, i: any) =>
            part.toLowerCase() === query?.toLowerCase()
                ? <span key={i} style={{ color: 'red' }}>{part}</span>
                : part
        );
    };

    //#region Search PlaceHolder
    const searchPlaceholder = [
        'Search "Shimla"',
        'Search "Goa"',
        'Search "Rajasthan"',
        'Search "Bangkok"',
        'Search "Honeymoon Special"',
        'Search "Family Tour"',
        'Search "Romantic Honeymoon Tour"',
    ];
    useEffect(() => {
        const interval = setInterval(() => {
            setIndexSearchPlaceholder((prevIndex) => (prevIndex + 1) % searchPlaceholder.length);
        }, 2000); // every 2 seconds

        return () => clearInterval(interval); // cleanup
    }, []);
    //#endregion

    const handleNavigateToPackage = (item: any) => {
        const obj = { type: item?.type, id: item?.id, name: item?.name }
        if (item?.type == "package")
            handleNavigate(obj);
        else
            handleNavigatePackages(obj);

    }

    return (
        <>
            {/* <CommonModal
                show={globalSearchPopup}
                onHide={() => togglePopup()}
                size="md"
                showHeader={false}
                showFooter={false}
                centered={false}
                contentClassName="modal-bg"
            > */}
            <input className={`searchTerm`}
                type="text"
                placeholder={searchPlaceholder[indexSearchPlaceholder]}
                value={query}
                onChange={handleChange}
            //style={{ width: '100%', padding: '8px' }}
            />
            {(query.length >= 3 && Object.entries(groupedResults)?.length > 0) && (
                <div className="global-search-result">
                    {Object.entries(groupedResults).map(([type, items]) => (
                        <div key={type}>
                            <strong>{type.toUpperCase()}</strong>
                            <ul style={{ paddingLeft: '20px' }}>
                                {items?.map((item: any, index: any) => (
                                    <li style={{ listStyle: "none", cursor: "pointer" }} key={`globalSearch_${index}`}
                                        onClick={() => {
                                            //togglePopup();
                                            setQuery('')
                                            handleNavigateToPackage(item);
                                        }}>{highlightText(item?.name, query)}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            )}
            {/* </CommonModal> */}
        </>
    )
}
export default GlobalSearch;